import moment from 'moment';
// import React from 'react';
import { Add, Remove } from '@mui/icons-material';
import { useMemo } from 'react';
import { ListTable } from '@/Components/ListTable';
import { convertWeightUnit } from '@/Helpers';

const TABLE_COLUMNS = [
	{
		title: 'SKU',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'QR Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'From Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'To Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	SKU: 'id',
	'Activity Date': 'activityDate',
	'Order ID': 'orderId',
	'QR Code': 'qrCode',
	'Stock Id': 'stockId',
	Quantity: 'variantId',
	'From Process': 'fromProcess',
	'To Process': 'toProcess',
};

const ProcessScanWiseTable = (props) => {
	const { data, measurement, itemDetails, allVariants } = props;
	const SPECIAL_ITEMS = {
		SKU: (id, itemObj) => {
			return (
				<div>
					{itemObj?.productName}
					{' '}
					(
					{itemObj?.variantName}
					)
				</div>
			);
		},
		QRCode: (qrCodeVal) => {
			return (
				<a
					className='underline text-blue-400'
					href={`/console2/order/tracking?type=qrCode&value=${qrCodeVal}`}
					target='_blank'
					rel='noreferrer'
				>
					{qrCodeVal}
				</a>
			);
		},
		Quantity: (variantId, itemObj) => {
			let unit = itemDetails?.unit ?? 'gram';
			if (!unit && measurement === 'US') {
				unit = 'oz';
			}
			let icon = <Add className='text-green-900' />;
			if (itemObj?.movementType === 'Stocked Out') {
				icon = <Remove className='text-red-800' />;
			}
			return (
				<div className='flex items-center gap-1'>
					<div className='animate-pulse'>{icon}</div>
					<p className=''>{convertWeightUnit(itemObj?.qty, unit)}</p>
				</div>
			);
		},
		'Activity Date': (date) => {
			return (
				<div className='w-[150px]'>
					{moment(date)?.format('YYYY-MM-DD HH:mm A')}
				</div>
			);
		},
	};

	const getRowStyles = (movementType) => {
		if (movementType === 'Stocked In') {
			return 'bg-[#00ff0d41]';
		}
		if (movementType === 'Stocked Out') {
			return 'bg-[#ff0c0c41]';
		}
		return '';
	};

	const filteredColumns = useMemo(() => {
		if (!allVariants) {
			return TABLE_COLUMNS.filter((ele) => {
				return ele?.title !== 'SKU';
			});
		}
		return TABLE_COLUMNS;
	}, [allVariants]);
	return (
		<div>
			<ListTable
				allowExport={false}
				allowCheckList={false}
				showBtnContainer={false}
				colMap={COLMAP}
				columns={filteredColumns}
				data={data?.map((ele) => {
					return {
						...ele,
						rowStyles: getRowStyles(ele?.movementType),
					};
				})}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};

export default ProcessScanWiseTable;
